<template>
    <div>
        <PCIndustryExperience 
            v-if="getInfor && !isMobile" 
            :json="json" 
        />        
        <MobIndustryExperience 
            v-else-if="getInfor && isMobile" 
            :json="json" 
        />
    </div>
</template>

<script>

    import MobIndustryExperience from '@/components/mobile/MobIndustryExperience'
    import PCIndustryExperience from '@/components/pc/PCIndustryExperience'

    // import jquery from 'jquery'

    import industryExperienceJson from '@/json/industry-experience'

    export default {
        name: 'IndustryExperience',
        props: {
            isMobile: Boolean
        },
        components: {
            PCIndustryExperience,
            MobIndustryExperience
        },
        data: function(){
            return {
                json: industryExperienceJson,
                getInfor: true
            }
        },
        mounted() {
            // let _this = this;
            // window.getAjaxJson = '';
            // jquery.get('./json/industry-experience.js', function(){
            //    _this.json = window.getAjaxJson;
            //    _this.getInfor = true;
            // });
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>